// app/components/form-sections/RecipientSection.jsx
"use client";
import Field from "../ui/Field";
import { HistoryDatalist } from "../ui/HistoryDatalist";

const RECIPIENT_FIELDS = [
  ["Recipient Name", "recipient_name", "e.g., Emma Johnson"],
  ["Recipient Title", "recipient_title", "e.g., Director"],
  ["Organization", "recipient_org", "e.g., DropDesk Coworking"],
  ["Address line 1", "recipient_addr1", "e.g., 321 Business Ave."],
  ["Address line 2", "recipient_addr2", "e.g., Charlotte, NC 28213"],
  ["Greeting salutation", "recipient_salutation", "e.g., Ms. Johnson"],
];

export default function RecipientSection({ form, setField, pushHistory, history }) {
  return (
    <div className="grid gap-4 mt-6">
      <span className="text-[13px] font-semibold text-slate-900">Recipient (Professional template)</span>
      {RECIPIENT_FIELDS.map(([label, key, ph]) => (
        <Field key={key} label={label}>
          <input
            placeholder={ph}
            className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
            value={form[key]}
            onChange={setField(key)}
            onBlur={(e) => pushHistory(key, e.target.value)}
            list={`hist-${key}`}
          />
          <HistoryDatalist id={`hist-${key}`} values={history[key] || []} />
        </Field>
      ))}
    </div>
  );
}
